import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractNegotiation } from '../../../models/Entities/Contracts/ContractNegotiation';
import { ContractNegotiationConcept } from '../../../models/Entities/Contracts/ContractNegotiationConcept';
import { NewContractNegotiationConcept } from '../../../models/Entities/Contracts/NewContractNegotiationConcept';
import { AppState } from '../../../redux/reducers';
import * as ContractNegotiationConceptStore from '../../../redux/middleware/ContractNegotiationConceptMiddleware';

export interface OwnProps {
  contractId: number;
  contractNegotiationId: string;
}

interface ConnectedProps {
  concepts: ContractNegotiationConcept[];
  isLoading: boolean;
  errorMessage?: string;
}

interface DispatchProps {
  GetContractNegotiationConcepts: typeof ContractNegotiationConceptStore.actionCreators.GetContractNegotiationConcepts;
  CreateContractNegotiationConcept: typeof ContractNegotiationConceptStore.actionCreators.CreateContractNegotiationConcept;
  UpdateContractNegotiationConcept: typeof ContractNegotiationConceptStore.actionCreators.UpdateContractNegotiationConcept;
  DeleteContractNegotiationConcept: typeof ContractNegotiationConceptStore.actionCreators.DeleteContractNegotiationConcept;
}

export type Props = OwnProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: OwnProps): ConnectedProps => {
  const contract: Contract | undefined =
    state.Contract?.list?.find((c: Contract) => c.id === ownProps.contractId);
  const negotiation: ContractNegotiation | undefined =
    contract?.negotiations?.find((n) => n.id === ownProps.contractNegotiationId);

  return {
    concepts: negotiation?.concepts || [],
    isLoading: negotiation?.isGettingNegotiationConcepts || false,
    errorMessage: negotiation?.ErrorGettingNegotiationConcepts?.ErrorMessage,
  };
};

export const mapDispatchToProps: DispatchProps = {
  GetContractNegotiationConcepts: ContractNegotiationConceptStore.actionCreators.GetContractNegotiationConcepts,
  CreateContractNegotiationConcept: ContractNegotiationConceptStore.actionCreators.CreateContractNegotiationConcept,
  UpdateContractNegotiationConcept: ContractNegotiationConceptStore.actionCreators.UpdateContractNegotiationConcept,
  DeleteContractNegotiationConcept: ContractNegotiationConceptStore.actionCreators.DeleteContractNegotiationConcept,
};
